import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import ProjectDetail from "./pdetail.js";

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100 p-6">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-center">
            SkillBridge Dashboard
          </h1>
          <p className="text-center text-gray-600">
            Merhaba Olci, bugün hangi becerini geliştirmek istersin?
          </p>
        </header>

        <Routes>
          <Route
            path="/"
            element={
              <main className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <section className="bg-white rounded-2xl shadow p-4 col-span-2">
                  <h2 className="text-xl font-semibold mb-2">Proje Listesi</h2>
                  <ul className="space-y-2 text-gray-800">
                    <li className="border p-3 rounded-lg bg-gray-50">
                      <Link to="/project/1">
                        1. Python ile Hava Durumu API’si Uygulaması
                      </Link>
                    </li>
                    <li className="border p-3 rounded-lg bg-gray-50">
                      <Link to="/project/2">
                        2. SQL ile Müşteri Segmentasyonu
                      </Link>
                    </li>
                    <li className="border p-3 rounded-lg bg-gray-50">
                      <Link to="/project/3">
                        3. React ile Basit Todo Uygulaması
                      </Link>
                    </li>
                    <li className="border p-3 rounded-lg bg-gray-50">
                      <Link to="/project/4">
                        4. Pandas ile Veri Temizleme Görevi
                      </Link>
                    </li>
                  </ul>
                </section>

                <section className="bg-white rounded-2xl shadow p-4">
                  <h2 className="text-xl font-semibold mb-2">Rozetler</h2>
                  <ul className="list-disc pl-4 text-gray-700">
                    <li>İlk Proje Tamamlandı</li>
                    <li>Geliştirici Seviye 1</li>
                  </ul>
                </section>

                <section className="bg-white rounded-2xl shadow p-4 col-span-2">
                  <h2 className="text-xl font-semibold mb-2">Proje Teslim</h2>
                  <form className="space-y-4">
                    <input
                      type="text"
                      placeholder="GitHub linkinizi girin"
                      className="w-full border p-2 rounded"
                    />
                    <input type="file" className="w-full border p-2 rounded" />
                    <button className="bg-blue-600 text-white px-4 py-2 rounded">
                      Gönder
                    </button>
                  </form>
                </section>

                <section className="bg-white rounded-2xl shadow p-4 col-span-2">
                  <h2 className="text-xl font-semibold mb-2">Geri Bildirim</h2>
                  <p className="text-gray-700">
                    Geri bildiriminiz hem mentorlar hem de yapay zeka tarafından
                    sağlanacaktır.
                  </p>
                </section>
              </main>
            }
          />
          <Route path="/project/:id" element={<ProjectDetail />} />
        </Routes>
      </div>
    </Router>
  );
}
